var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('div',{staticClass:"Project"},[_c('div',{staticClass:"Project__icons",attrs:{"if":"icons.length"}},_vm._l((_vm.icons),function(icon){return _c('Icon',{key:icon.url,attrs:{"icon":icon}})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }